import { render, staticRenderFns } from "./RTdatenschutz.vue?vue&type=template&id=7aecf33d&scoped=true&"
import script from "./RTdatenschutz.vue?vue&type=script&lang=js&"
export * from "./RTdatenschutz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aecf33d",
  null
  
)

export default component.exports